export enum ProjectRole {
  ProjectOwner = 'ProjectOwner',
  ProjectContributor = 'ProjectContributor',
  ProjectReader = 'ProjectReader',
  DefaultRole = 'DefaultRole',
}
